<template>
	<div>
		<div 
      class="mb-6 flex items-center justify-between"
    >
      <h2 
        class="font-semibold text-lg text-black"
      >
        Propiedades
      </h2>
      <button
        @click="showModal = true"
        class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 hover:text-white flex items-center justify-center gap-2 sm:px-4 sm:py-2.5 p-2.5 sm:rounded-lg rounded-full transition text-sm font-medium"
      >
        <svg class="only-dest" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.21217 0 4.41566 0.0842856 4.56569 0.234315C4.71571 0.384344 4.8 0.587827 4.8 0.8V3.2H7.2C7.41217 3.2 7.61566 3.28429 7.76569 3.43431C7.91571 3.58434 8 3.78783 8 4C8 4.21217 7.91571 4.41566 7.76569 4.56569C7.61566 4.71571 7.41217 4.8 7.2 4.8H4.8V7.2C4.8 7.41217 4.71571 7.61566 4.56569 7.76569C4.41566 7.91571 4.21217 8 4 8C3.78783 8 3.58434 7.91571 3.43431 7.76569C3.28429 7.61566 3.2 7.41217 3.2 7.2V4.8H0.8C0.587827 4.8 0.384344 4.71571 0.234315 4.56569C0.0842856 4.41566 0 4.21217 0 4C0 3.78783 0.0842856 3.58434 0.234315 3.43431C0.384344 3.28429 0.587827 3.2 0.8 3.2H3.2V0.8C3.2 0.587827 3.28429 0.384344 3.43431 0.234315C3.58434 0.0842856 3.78783 0 4 0V0Z" class="fill-tuin-100 group-hover:fill-white"/>
        </svg>
        <svg class="only-mob fill-tuin-100 stroke-tuin-100 group-hover:fill-white group-hover:stroke-white transition" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 8H1H8Z"/>
          <path d="M8 1V8M8 8V15M8 8H15M8 8H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span 
          class="only-dest"
        >
          Asignar Propiedad
        </span>
      </button>
    </div>

    <div 
      v-if="props.properties.length > 0"
    >
      <div 
        class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
      >
        <LeadsPropertyCard
          v-for="(property, index) in props.properties"
          :key="index"
          :data="property"
        />
      </div>
    </div>

		<div v-else 
      class="flex flex-col items-center justify-center text-center py-8"
    >
      <div 
        class="flex justify-center items-center mb-3"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
					<path d="M37.5 32.4999H35V21.2499L35.3656 21.6155C35.6006 21.8501 35.9191 21.9817 36.2511 21.9814C36.5831 21.9811 36.9014 21.8489 37.1359 21.614C37.3705 21.379 37.5021 21.0605 37.5018 20.7285C37.5015 20.3965 37.3693 20.0782 37.1344 19.8437L21.7672 4.48117C21.2984 4.01268 20.6628 3.74951 20 3.74951C19.3372 3.74951 18.7016 4.01268 18.2328 4.48117L2.86563 19.8437C2.63128 20.0782 2.49971 20.3963 2.49986 20.7278C2.5 21.0594 2.63186 21.3773 2.86641 21.6116C3.10096 21.846 3.41899 21.9775 3.75055 21.9774C4.08211 21.9773 4.40003 21.8454 4.63438 21.6109L5 21.2499V32.4999H2.5C2.16848 32.4999 1.85054 32.6316 1.61612 32.866C1.3817 33.1005 1.25 33.4184 1.25 33.7499C1.25 34.0814 1.3817 34.3994 1.61612 34.6338C1.85054 34.8682 2.16848 34.9999 2.5 34.9999H37.5C37.8315 34.9999 38.1495 34.8682 38.3839 34.6338C38.6183 34.3994 38.75 34.0814 38.75 33.7499C38.75 33.4184 38.6183 33.1005 38.3839 32.866C38.1495 32.6316 37.8315 32.4999 37.5 32.4999ZM7.5 18.7499L20 6.24992L32.5 18.7499V32.4999H25V23.7499C25 23.4184 24.8683 23.1005 24.6339 22.866C24.3995 22.6316 24.0815 22.4999 23.75 22.4999H16.25C15.9185 22.4999 15.6005 22.6316 15.3661 22.866C15.1317 23.1005 15 23.4184 15 23.7499V32.4999H7.5V18.7499ZM22.5 32.4999H17.5V24.9999H22.5V32.4999Z" fill="#737373"/>
				</svg>
      </div>
      <p 
        class=" text-base text-gray-900"
      >
        No tiene una propiedad de interés asignada
      </p>
    </div>
		
    <ModalPropertiesComponent
      v-if="showModal"
      :prospect-id="props.leadId"
      @close="showModal = false"
      @propertyUpdated="handlePropertyUpdated"
    />
	</div>
</template>
<script setup>
import { ref } from 'vue';
import LeadsPropertyCard from "@/components/leads/LeadsPropertyCard.vue";
import ModalPropertiesComponent from "@/components/leads/Modal/ModalPropertiesComponent.vue";
const props = defineProps({
  properties: {
    type: Array,
    default: () => []
  },
  leadId: {
    type: Number,
    required: true,
  },
});

let showModal = ref(false);
const emit = defineEmits(['reloadProperties']);

const handlePropertyUpdated = () => {
  // Emitir evento al componente padre para recargar solo propiedades
  emit('reloadProperties');
};
</script>